<template>
  <div>
    <el-progress
      type="circle"
      :percentage="percentage"
      :stroke-width="8"
      :color="color"
    />
  </div>
</template>

<script>
  import { api } from '../plugins/axios'

  export default {
    name: 'EmJobStatus',
    props: {
      value: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        fakedPercentage: 0,
        fakeTimer: null,
        timer: null
      }
    },

    computed: {
      percentage () {
        const total = this.value.chain.total
        const done = this.value.chain.done
        let base = 0

        // base percentage is based on the jobs status
        if (this.value.chain) {
          base = done / total
        } else if (this.value.status === 'done') {
          base = 1
        }

        const reservedPercentage = Math.floor((((done + 1) / total) * 100))
        let intendedPercentage = Math.floor((base * 100) + this.fakedPercentage)

        // we should stop current job percentage entering
        // reserved percentage space of next job
        if (intendedPercentage > reservedPercentage) {
          intendedPercentage = reservedPercentage
        }

        // max of 100 obviously
        if (intendedPercentage > 100) {
          intendedPercentage = 100
        }

        return intendedPercentage
      },

      color () {
        return this.faulty
          ? '#f56c6c'
          : '#20a0ff'
      },

      faulty () {
        return this.value.status === 'error'
      },

      done () {
        return this.value.status === 'done'
      }
    },

    watch: {
      'value.chain.done' () {
        this.fakedPercentage = 0
      }
    },

    mounted () {
      this.createRefreshTimer()
    },

    methods: {
      createFakeProgressTimer () {
        if (this.fakeTimer) {
          return
        }

        if (this.percentage > 89) {
          // we do not create a fake timer anymore as we do not want to fake too much
          return
        }

        const duration = Math.floor(Math.random() * (10 - 1) + 1)

        this.fakeTimer = window.setTimeout(() => {
          this.fakedPercentage++
          this.fakeTimer = null

          if (this.percentage < 100) {
            this.createFakeProgressTimer()
          }
        }, duration * 1000)
      },

      createRefreshTimer () {
        window.setTimeout(() => {
          api.get(`/api/v1/jobs/${this.value.id}`).then(({ data }) => {
            this.$emit('input', data)

            if (!this.faulty && !this.done) {
              this.createFakeProgressTimer()
              this.createRefreshTimer()
            }
          })
        }, 5000)
      }
    }
  }
</script>
